import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useCurrentTime } from "../../../shared/hooks/useCurrentTime"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { useDateTime } from "../../localization/useDateTime"

import { MENU_DISPLAY_DISPLAY_FONT } from "./menuDisplayData"

const CLOCK_TICK_MS = 1000

const useStyles = makeStyles()((theme) => ({
    header: {
        flexShrink: 0,
        padding: "1.5em 3.5em",
        borderBottom: `.1875em solid ${theme.palette.tailwind.slate[200]}`,
    },
    brandGroup: {
        minWidth: 0,
    },
    logo: {
        flexShrink: 0,
        width: "7.5em",
        height: "7.5em",
        marginRight: "2.5em",
        borderRadius: ".625em",
        objectFit: "contain",
        display: "block",
    },
    titles: {
        minWidth: 0,
    },
    brand: {
        color: theme.palette.tailwind.slate[700],
        fontWeight: 600,
        fontSize: "1.5em",
        lineHeight: 1,
        letterSpacing: ".06em",
        textTransform: "uppercase",
    },
    title: {
        color: theme.palette.tailwind.slate[700],
        fontFamily: MENU_DISPLAY_DISPLAY_FONT,
        fontWeight: 600,
        fontSize: "4em",
        lineHeight: 1.25,
        letterSpacing: 0,
        textTransform: "uppercase",
    },
    clock: {
        flexShrink: 0,
        color: theme.palette.tailwind.slate[700],
        fontFamily: MENU_DISPLAY_DISPLAY_FONT,
        fontWeight: 600,
        fontSize: "4em",
        lineHeight: 1.25,
        letterSpacing: 0,
    },
}))

type Props = Readonly<{
    title?: string
    logoUrl?: string
}>

export function MenuDisplayHeader({ title, logoUrl }: Props) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()
    const now = useCurrentTime(CLOCK_TICK_MS)

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" className={classes.header}>
            <Stack direction="row" alignItems="center" className={classes.brandGroup}>
                {logoUrl && <img className={classes.logo} src={logoUrl} alt={title ?? ""} />}
                <Stack direction="column" spacing=".5em" className={classes.titles}>
                    {title && <Typography className={classes.brand}>{title}</Typography>}
                    <LocalizedStrict id="public-menu-display-header-title">
                        <Typography className={classes.title}>Today's menu</Typography>
                    </LocalizedStrict>
                </Stack>
            </Stack>
            <Typography className={classes.clock}>{dateTimeFactory.formatTime(now)}</Typography>
        </Stack>
    )
}
